export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true},
 clients: {"default": {"httpEndpoint": "/graphql", "authType": "Bearer", "authHeader": "Authorization", "tokenStorage": "cookie", "proxyCookies": false, "clients": {}, "tokenName": "apollo:default.token", "defaultOptions": undefined}}
}